import { render, staticRenderFns } from "./new_quotation.vue?vue&type=template&id=60a45465"
import script from "./new_quotation.vue?vue&type=script&lang=js"
export * from "./new_quotation.vue?vue&type=script&lang=js"
import style0 from "./new_quotation.vue?vue&type=style&index=0&id=60a45465&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports